import { combineReducers } from 'redux';
import { cart } from './Reducers/Cart.reducer';
import { cartErrors } from './Reducers/Cart.Errors.reducer';
import { quickSearch } from './Reducers/QuickSearch.reducer';
import { navigation } from './Reducers/Navigation.reducer';
import { checkout } from './Reducers/Checkout.reducer';
import { myPage } from './Reducers/MyPage.reducer';
import { overlay } from './Reducers/Overlay.reducer';
import { currencyFormat } from './Reducers/CurrencyFormat.reducer';
import productFiltering from './Reducers/ProductFiltering.reducer';
import { productListing } from './Reducers/ProductListing.reducer';
import { search } from './Reducers/Search.reducer';
import { buyButton } from './Reducers/BuyButton.reducer';
import { login } from './Reducers/Login.reducer';
import userInfoSlice from './Reducers/UserInfo.reducer';
import { priceHistory } from './Reducers/PriceHistory.reducer';
import { notPriced } from './Reducers/NotPriced.reducer';
import newsList from './Reducers/NewsList.reducer';
import overlaySlice from './Slices/OverlaySlice';

const staticReducers = {
  cart,
  cartErrors,
  quickSearch,
  navigation,
  checkout,
  myPage,
  overlay,
  productFiltering,
  productListing,
  search,
  buyButton,
  login,
  userInfo: userInfoSlice,
  priceHistory,
  notPriced,
  newsList,
  currencyFormat,
  overlaySlice,
};

const rootReducer = combineReducers(staticReducers);

export const createReducer = (asyncReducers: any) => {
  return combineReducers({
    ...staticReducers,
    ...asyncReducers,
  });
};

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
